import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { WeeklyResultByStoreReportService } from '../weekly-result-by-store-report/weekly-result-by-store-report.service';
import { ShopinfoService } from '../../system/shopinfo/shopinfo.service';
import { ShopinfoModel } from '../../system/shopinfo/model/shopinfo.model';
import { DepartmentService } from '../../system/department/department.service';
import { FormsModule } from '@angular/forms';
import moment from 'moment';
import { DailySalesService } from './daily-sales.service';
import { UserInfoModel } from 'src/app/common/models/user-info.model';
import { AppConstants } from 'src/app/common/app.constants';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-hq-daily-sales-report',
  standalone: false,
  templateUrl: './daily-sales.component.html',
  styleUrl: './daily-sales.component.scss'
})
export class HqDailySalesComponent {

  user: UserInfoModel | undefined;
  title: string = "Sales Summary(Daily)";
  IsDownloading: boolean = false;
  editForm: FormGroup;
  currentYear: number;
  // years: number[];
  selectedYear: any;
  weeks: any[] = [];
  departmentListData: any = [];
  // In your component class
  financialYears: any[] = []; // This will store the finYears array from API
  years: number[] = []; // This will store just the year numbers if needed separately
  filteredShopList: any[] = [];




  curFinYear!: string; // Add this to your component properties  
  daysOfWeek: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  hours: string[] = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  fromHour: string = '00';
  toHour: string = '00';
  shop_id: any;
  shop_name: any;
  departmentValidationMessage: any;
  departmentSelectionInvalid: boolean = false;
  resetButtonEnabled: boolean = false;
  shopListData: any = [];
  permission: any;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private dailySalesService: DailySalesService,
    private snackBarService: SnackBarService,
    private ShopinfoService: ShopinfoService,
    private departmentService: DepartmentService,
    private permissionService: PermissionService,
    public dialog: MatDialog,) {

    const today = new Date();
    this.editForm = this.builder.group({
      period_from: this.builder.control(today, Validators.required),
      period_to: this.builder.control(today, Validators.required),
      // shop_id: this.builder.control('', [Validators.required, this.shopValidator.bind(this)]),
      shop_id: this.builder.control('ALL', [Validators.required, this.shopValidator.bind(this)]),
    }, { validators: this.dateRangeWithinOneYearValidator() }); // <-- add validator here

    this.currentYear = new Date().getFullYear();
    // this.years = this.generateYears();

    // Automatically save to sessionStorage when form values change
    this.editForm.valueChanges.subscribe(() => {
      this.saveToSessionStorage();
    });

    this.shopList();
    this.permission = permissionService.getPagePermission("daily-sales-summary");
    console.log(this.permission);
  }

  ngOnInit(): void {
    // this.loadData();
    this.shopList();
    let sesUser = sessionStorage.getItem(AppConstants.SESSION_VAR_USER);
    this.user = (sesUser !== null) ? JSON.parse(sesUser) : undefined;
    console.log(this.user)
    console.log(this.filteredShopList);

  }

  selectedDays(): string[] {
    const days = this.editForm.get('days')?.value;
    return Object.keys(days).filter(day => days[day]);
  }

  shopList(): void {

    let requestData = { search: { filters: { filter: [], scope: { offset: 0, limit: 1000000 } }, sort: [{ column: "shop.name", order: "ASC" }] } }

    this.dailySalesService.getShopList(requestData).subscribe({
      next: (response: any) => {
        this.shopListData = response.data.shops;
        this.filteredShopList = response.data.shops;
      },
      error: (error: any) => {
        // Handle error here
        console.error('Error fetching users:', error);
      }
    })


  }
  // Custom validator function
  hourRangeValidator(): ValidatorFn {
    return (group: AbstractControl): { [key: string]: any } | null => {
      const from = group.get('fromHour')?.value;
      const to = group.get('toHour')?.value;

      if (from != null && to != null && from > to) {
        return { invalidHourRange: true };
      }
      return null;
    };
  }
  getCurrentWeek(weeks: any[]): any {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return weeks.find(week => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      return today >= startDate && today <= endDate;
    });
  }


  sortOptions = [
    { value: 'shop_name', label: 'Shop Name' },
    { value: 'this_year_this_week_sales', label: 'This Year Sales' },
    { value: 'last_year_this_week_sales', label: 'Last Year Sales' },
    { value: 'this_week_cust_orders', label: 'This Year Customer Orders' },
    { value: 'last_year_cus_order', label: 'Last Year Customer Orders' },
    { value: 'this_week_labour_cost', label: 'This Year Labour Cost' },
    { value: 'last_year_this_week_labour_cost', label: 'Last Year Labour Cost' },
  ];

  sortOrderOptions = [
    { value: 'asc', label: 'Ascending' },
    { value: 'desc', label: 'Descending' }
  ];

  saveToSessionStorage(): void {
    // Get selected shop IDs (if none are selected, treat it as "ALL")
    const selectedDepartmentIds = this.departmentListData
      .filter((shop: any) => shop.selected)
      .map((shop: any) => shop.item.id);

    // If no shops are selected, we treat it as "ALL" (empty array means all shops)
    const departmentIds = selectedDepartmentIds.length > 0 ? selectedDepartmentIds : [];
    if (selectedDepartmentIds.length > 0) {
      this.resetButtonEnabled = true;
    } else {
      this.resetButtonEnabled = false;
    }

    // Create the data object
    const reportData = {
      year: this.editForm.get('year')?.value,
      weekNo: this.editForm.get('week_no')?.value,
      shopId: departmentIds,
      sortBy: this.editForm.get('sort_by')?.value,
      sortDir: this.editForm.get('sort_order')?.value,
      isExport: 0
    };

    // Save to sessionStorage
    sessionStorage.setItem('hourlySalesReportData', JSON.stringify(reportData));
  }

  loadFromSessionStorage(): void {
    const savedData = sessionStorage.getItem('weeklyStoreReportData');
    // console.log(savedData)
    if (savedData) {
      const reportData = JSON.parse(savedData);

      // Set form values
      this.editForm.patchValue({
        year: reportData.year,
        week_no: reportData.weekNo,
        sort_by: reportData.sortBy,
        sort_order: reportData.sortDir
      }, { emitEvent: false }); // Prevent infinite loop

      // Set shop selections (if shop IDs were saved)
      if (reportData.shopId && reportData.shopId.length > 0) {
        this.departmentListData.forEach((shop: any) => {
          shop.selected = reportData.shopId.includes(shop.item.id);
        });
      } else {
        // If no shops were selected before, reset all to false (treat as "ALL")
        this.departmentListData.forEach((shop: any) => shop.selected = false);
      }

      // Manually trigger year change if needed
      if (reportData.year) {
        this.onYearChange();
      }
    }
  }




  onYearChange(): void {
    this.selectedYear = this.editForm.get('year')?.value;
    console.log('Selected Year:', this.selectedYear);

    // Find the selected financial year from financialYears array
    const selectedFinYear = this.financialYears.find(fy => fy.year === this.selectedYear);

    if (selectedFinYear) {
      // Map the weeks to the format needed for the dropdown
      this.weeks = selectedFinYear.weeks.map((week: any) => ({
        ...week,
        displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date} - ${week.end_date})`
      }));

      // Set the first week as default if weeks exist
      if (this.weeks.length > 0) {
        this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
      }
    } else {
      this.weeks = [];
      this.editForm.get('week_no')?.setValue(null);
    }
  }

  padWeekNumber(weekNo: number): string {
    return weekNo.toString().padStart(2, '0');
  }


  getSelectedCount(sourceList: any[]): any {
    var count = 0;
    sourceList.forEach(el => {
      if (el.selected) {
        count++;
      }
    })
    return sourceList.length + '/' + ((count > 0) ? (count) : 'ALL');
  }

  reset(sourceList: any[]): any {
    sourceList.forEach(el => {
      el.selected = false;
    });
  }


  onShopSelectionChange(): void {
    this.saveToSessionStorage();
  }


  shopValidator(control: AbstractControl) {
    if (!control.value) return { invalidShop: true };
    if (control.value === 'ALL') return null; // Allow "ALL"
    if (typeof control.value === 'object' && this.shopListData.some((shop: { id: any; }) => shop.id === control.value.id)) {
      return null;
    }
    if (typeof control.value === 'string' && this.shopListData.some((shop: { name: any; }) => shop.name === control.value)) {
      return null;
    }
    return { invalidShop: true };
  }

  navigateToWeeklyReport() {
    this.router.navigate(['/weekly-result-store-report-view']);
    // or with parameters if needed:
    // this.router.navigate(['/weekly-result-store-report-view', {param: value}]);
  }

  // Validator to ensure date range is <= 365 days
  dateRangeWithinOneYearValidator(): ValidatorFn {
    return (group: AbstractControl): { [key: string]: any } | null => {
      const from = group.get('period_from')?.value;
      const to = group.get('period_to')?.value;
      if (from && to) {
        const fromDate = moment(from);
        const toDate = moment(to);
        if (toDate.diff(fromDate, 'days') >= 365) {
          return { dateRangeTooLong: true };
        }
      }
      return null;
    };
  }

  exportClicked(): void {
    if (this.editForm.invalid) {
      // Check for date range error
      if (this.editForm.errors && this.editForm.errors['dateRangeTooLong']) {
        let snackBarData: SnackBarData = {
          message: 'Please choose a date range shorter than 365 days.',
          title: 'Invalid Date Range',
          type: 'warn'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
      this.editForm.markAllAsTouched();
      return;
    }
    this.IsDownloading = true;

    var rawDateFrom = this.editForm.get('period_from')?.value;
    var formattedDateFrom = (rawDateFrom !== null) ? moment(rawDateFrom).format('DD-MM-YYYY') : rawDateFrom;
    var rawDateTo = this.editForm.get('period_to')?.value;
    var formattedDateTo = (rawDateTo !== null) ? moment(rawDateTo).format('DD-MM-YYYY') : rawDateTo;
    const selectedShopId = this.editForm.get('shop_id')?.value;
    const shopId = selectedShopId === 'ALL' ? null : selectedShopId;

    const reportData = {
      dateFrom: formattedDateFrom,
      dateTo: formattedDateTo,
      shopId: shopId
    };
    if (reportData) {
      this.IsDownloading = true;

      this.dailySalesService.exportDailySales(reportData).subscribe({
        next: (response: Blob) => {
          const reader = new FileReader();

          reader.onload = () => {
            try {
              const text = reader.result as string;
              const json = JSON.parse(text);

              // Check for no data found status
              if (json.status === 'NO_DATA_FOUND') {
                let snackBarData: SnackBarData = {
                  message: 'No data found for the selected criteria.',
                  title: 'No Data Found!',
                  type: 'warn'
                };
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // Check for other error statuses
              if (json.status === 'ERROR' || json.status === 'FAILED') {
                let snackBarData: SnackBarData = {
                  message: json.message || 'An error occurred while generating the report.',
                  title: 'Error!',
                  type: 'error'
                };
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // If we reach here with a JSON response, show warning
              let snackBarData: SnackBarData = {
                message: 'Unexpected response format from server.',
                title: 'Warning!',
                type: 'warn'
              };
              this.IsDownloading = false;
              this.snackBarService.openSnackBar(snackBarData);

            } catch (e) {
              // If JSON parsing fails, it's likely a binary file (Excel)
              // Check if the response is empty or very small
              if (response.size === 0) {
                let snackBarData: SnackBarData = {
                  message: 'No data available for export.',
                  title: 'No Data Found!',
                  type: 'warn'
                };
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // Check if response is too small to be a valid file
              if (response.size < 100) {
                let snackBarData: SnackBarData = {
                  message: 'No data found for the selected criteria.',
                  title: 'No Data Found!',
                  type: 'warn'
                };
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // Valid binary file - proceed with download
              const blob = new Blob([response], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = 'dashboard_sales.xlsx';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
              this.IsDownloading = false;

              // Show success message
              let snackBarData: SnackBarData = {
                message: 'Report downloaded successfully.',
                title: 'Success!',
                type: 'success'
              };
              this.snackBarService.openSnackBar(snackBarData);
            }
          };

          reader.readAsText(response);
        },
        error: (error) => {
          console.error('Error fetching report:', error);
          this.IsDownloading = false;

          let snackBarData: SnackBarData = {
            message: 'An error occurred while fetching the report. Please try again.',
            title: 'Error!',
            type: 'error'
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      });
    }
  }


  filterShops() {
    const value = this.editForm.get('shop_id')?.value;
    if (!value || value === '' || value === 'ALL' || (typeof value === 'object' && value.name === 'ALL')) {
      this.filteredShopList = this.shopListData.slice();
      return;
    }

    const filterValue = typeof value === 'string' ? value.toLowerCase() : (value?.name?.toLowerCase() || '');
    this.filteredShopList = this.shopListData.filter((shop: { name: string; }) =>
      shop.name.toLowerCase().includes(filterValue)
    );

  }

  clearShop() {
    this.editForm.get('shop_id')?.setValue('');
    this.filteredShopList = this.shopListData.slice();
  }
  displayShop(shop: any): string {
    if (shop === 'ALL') return 'All';
    return shop && shop.name ? shop.name : '';
  }

}